
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/moloco",
      function () {
        return require("private-next-pages/destinations/moloco.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/moloco"])
      });
    }
  